import React from 'react';

export default function Mail() {
	return (
		<svg
			width="14"
			height="12"
			viewBox="0 0 14 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.5 0.666656C0.856003 0.666656 0.333336 1.18932 0.333336 1.83332L7 5.99999L13.6667 1.83332C13.6667 1.18932 13.144 0.666656 12.5 0.666656H1.5ZM0.333336 3.16796V9.99999C0.333336 10.7367 0.930003 11.3333 1.66667 11.3333H12.3333C13.07 11.3333 13.6667 10.7367 13.6667 9.99999V3.16796L7 7.33332L0.333336 3.16796Z"
				fill="white"
			/>
		</svg>
	);
}
